import { ApiEntity } from '@app/entities/api.entity';
import { environment } from '@environment';

export const userApi: ApiEntity = {
  data: {
    url: `${environment.api.services}/ms/application-user/auth`,
  },
  info: {
    url: `${environment.api.services}/api/travel-content-admin-ms/user/info`,
  },
  get_benefits: {
    url: `${environment.api.services}/api/travel-benefits-ms/benefits`,
  },
  statics_lists: {
    url: `${environment.api.services}/api/travel-content-admin-ms/static/lists`,
  }
};

export const userAddressesApi: ApiEntity = {
  data: {
    url: `${environment.api.services}/api/ms/users-address/addresses`,
  },
  cities: {
    url: `${environment.api.services}/api/ms/city-addresses/legacy`,
  },
  active: {
    url: `${environment.api.server}/api/ms/users-address/address`,
  },
  create: {
    url: `${environment.api.services}/api/ms/users-address/address`,
  }
};

export const seamlessLoginApi = {
  auth_user: {
    url: `${environment.api.services}/api/travel-proxy-ms/seamless-login`
  },
  guest_user: {
    url: `${environment.api.services}/api/travel-proxy-ms/session/guest`
  } 
};

export const authSeamlessLoginApi = {
  url: `${environment.api.netactica}/SeamlessLogin/Authenticate`
};
